export default {

    navConfig: {
        logoUrl: 'https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/dlc/home/logo.png',
        bgColor: 'rgb(4, 157, 237)',
        textColor: '#fff',
        activeTextColor: 'rgb(4, 157, 237)'
    },
    accountConfig: {
        notUseWx: true,
        notFavorite: true,
    },
    pageConfig: {
        companyPage: {
            url: '/companyDetail',
            isEncode: true,
        },
    },
    sendCard: true,//发送名片，等待对方确认
}